
import { defineComponent } from 'vue';
import ListOfSuras from '@/components/commentary/ListOfSuras.vue';

export default defineComponent({ components: { ListOfSuras } });
